import { useRouter } from 'next/router';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { CLOUD_FRONT_IMAGE_PATH } from 'src/constants/imagePath';
import { LOCALE_TYPE } from 'src/types/locale';
import { authorize } from 'src/utils/authorize';
import { mixpanel } from 'src/utils/mixpanel';

const IMAGE_BASE_PATH = `${CLOUD_FRONT_IMAGE_PATH}/shared/signup-coupon/banner`;

export const RegisterCampaignBannerForPc = () => {
  const { locale } = useRouter();
  return (
    <div className="hidden semiLg:block sticky top-16 max-w-[1110px] z-[15] w-full mx-auto">
      <div
        className="absolute w-[92px] h-[292px] top-[70px] left-[-102px] cursor-pointer hover:opacity-75"
        onClick={() => {
          mixpanel.onAccountRegistration();
          authorize('signUp');
        }}
      >
        <NextImage src={`${IMAGE_BASE_PATH}/pc_${locale ?? LOCALE_TYPE.TW}.webp`} alt="" width={92} height={292} />
      </div>
    </div>
  );
};
